import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';

@Injectable({
  providedIn: 'root'
})
export class ManualArticleApiService extends ApiService {
  readonly resourcePath = 'manual_articles';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<any>> {
    return this.restList<any>(filters);
  }

  get(id: string): Observable<any> {
    return this.restRead<any>(id);
  }

  getBySlug(manualId:string, slug:string){
    return this.http.get(this.apiUrl+'/manual_articles_slug/'+slug+'?manual='+manualId);
  }
}
